import { render, staticRenderFns } from "./PptToEnbxPage.vue?vue&type=template&id=5ed3ea53"
import script from "./PptToEnbxPage.vue?vue&type=script&lang=ts"
export * from "./PptToEnbxPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports